import { ApplicationOrigin } from 'app/stores/globalStore';
import { ProductPaymentRequest } from 'app/types/initializePayment';
import { CartItem } from 'app/types/product';

import { ProductPriceLike } from './productDto';

// Tipos mínimos: así estas utilidades sirven tanto para el Product completo
// como para el ProductCardData ligero que reciben las tarjetas y carruseles.
type ProductSeasonLike = {
  title?: string;
  extraInformation?: { slug?: string };
};
type ProductAvailabilityLike = ProductSeasonLike & { clinicDetail?: unknown[] };

export function getDiscountedPrice(
  product: ProductPriceLike,
  currentOrigin: ApplicationOrigin,
  clinic: string | undefined = undefined
) {
  let totalDiscountSum = 0;
  if (product && product.discounts && product.discounts.length > 0) {
    product.discounts.forEach(x => {
      let applyByClinic = false;
      if (
        clinic &&
        x.productDiscountClinics &&
        x.productDiscountClinics.length > 0
      ) {
        applyByClinic =
          x.productDiscountClinics.find(
            y => y.clinicInfo.id.toLowerCase() === clinic.toLowerCase()
          ) != undefined;
      } else if (
        !clinic &&
        x.productDiscountClinics &&
        x.productDiscountClinics.length > 0
      )
        applyByClinic = false;
      else applyByClinic = true;

      if (applyByClinic) {
        if (currentOrigin == ApplicationOrigin.Landing && x.visibleLanding)
          totalDiscountSum += x.totalDiscount;
        else if (
          currentOrigin == ApplicationOrigin.Dashboard &&
          x.visibleDashboard
        )
          totalDiscountSum += x.totalDiscount;
        else if (currentOrigin == ApplicationOrigin.Web && x.visibleWeb)
          totalDiscountSum += x.totalDiscount;
      }
    });
  }
  return totalDiscountSum === 0 ? null : product?.price - totalDiscountSum;
}

// Productos con disponibilidad estacional: ocultos (estado "próximamente")
// de junio a agosto, visibles de septiembre a mayo.
export function isSeasonalProduct(product: ProductSeasonLike): boolean {
  const isIPL =
    product.extraInformation?.slug?.toLowerCase().includes('ipl') ||
    product.title?.toLowerCase().includes('ipl');
  const isPeelingQuimico = product.title?.toLowerCase().includes('peeling químico');
  return Boolean(isIPL || isPeelingQuimico);
}

// junio (mes 5) – agosto (mes 7), ambos inclusive
function isSeasonalOffSeason(): boolean {
  const month = new Date().getMonth();
  return month >= 5 && month <= 7;
}

export function getIsComingSoon(product: ProductAvailabilityLike): boolean {
  const noClinics =
    !Array.isArray(product?.clinicDetail) || product.clinicDetail.length === 0;
  if (noClinics) return true;
  return isSeasonalProduct(product) && isSeasonalOffSeason();
}

export function getComingSoonLabel(product: ProductSeasonLike): string {
  return isSeasonalProduct(product) ? 'Vuelve en septiembre' : 'Próximamente';
}

export function buildProductPaymentRequest(
  cart: CartItem[],
  origin: ApplicationOrigin,
  clinicId?: string
): ProductPaymentRequest[] {
  return cart.map(product => {
    const discountedPrice = getDiscountedPrice(product, origin, clinicId);
    return {
      name: product.title,
      price: discountedPrice
        ? discountedPrice.toString()
        : product.price.toString(),
      quantity: '1',
      id: product.id.toUpperCase(),
    };
  });
}

/** Si el producto se ofrece en la clínica (según `clinicDetail` de la API). */
export function isProductOfferedInClinic(
  product: { clinicDetail?: { clinic?: { id?: string } }[] },
  clinicId: string
): boolean {
  if (!clinicId) return false;
  return (product?.clinicDetail ?? []).some(
    item => item?.clinic?.id?.toLowerCase() === clinicId.toLowerCase()
  );
}
